import React from "react";
import clsx from "clsx";

interface SheetProps {
  direction?: "left" | "right" | "top" | "bottom";
  isOpen: boolean;
  onClose: any;
  children: React.ReactNode;
  closeColor?: string;
}

const Sheet: React.FC<SheetProps> = ({
  direction = "right",
  isOpen,
  onClose,
  children,
  closeColor
}) => {
  const [translate, setTranslate] = React.useState(false);
  const positionClasses = {
    left: "left-0 top-0 h-full w-3/4 -translate-x-full",
    right: "right-0 top-0 h-full w-3/4 translate-x-full",
    top: "top-0 left-0 w-full h-3/4 -translate-y-full",
    bottom: "bottom-0 left-0 w-full h-3/4 translate-y-full",
  };

  return (
    <>
      {/* Overlay */}
      <div
        className={`
          fixed inset-0 bg-black z-[1000] bg-opacity-50 backdrop-blur-[4px] transition-all duration-300",
          ${!isOpen && "opacity-0 pointer-events-none"}  ${
          isOpen && "opacity-100"
        }
        `}
        onClick={onClose}
      />

      {/* Sliding Panel */}
      <div
        className={`
          fixed bg-white shadow-lg z-[1001] transition-all duration-300 ease-in-out
          right-0 top-0 w-[80vw] md:w-1/2 lg:w-1/4 lg:min-w-fit h-screen
          ${isOpen ? " translate-x-0" : "translate-x-full"}
        `}
      >
        <div className="relative h-full">
          {/* Close Button */}
          <button
            className={`absolute top-2 right-2 px-2 py-1 transition-all z-[12] rounded-full hover:bg-gray-200 ${closeColor}`}
            onClick={onClose}
          >
            ✕
          </button>
          <div className="h-full overflow-auto scrollbar-hide">{children}</div>
        </div>
      </div>
    </>
  );
};

export default Sheet;
